import { useAtomValue } from "jotai"

import { useProfileMetaById } from "@/entities/profile"
import { useProfileHydrator } from "./hooks/useProfileHydrator"
import { useTaskStream } from "./hooks/useTaskStream"
import { selectedProfileIdAtom } from "./store"

function TaskStreamSubscriber({
  profileId,
  taskId,
}: {
  profileId: string
  taskId: string
}) {
  useTaskStream(profileId, taskId)
  return null
}

function ProfileHydratorSubscriber({ profileId }: { profileId: string }) {
  useProfileHydrator(profileId)
  return null
}

/**
 * Mounts one task-stream subscriber per active processing task and a
 * profile hydrator for the selected profile. Replaces RecsysBackgroundService.
 */
export function RecsysSubscriptions() {
  const profileMetaById = useProfileMetaById()
  const selectedProfileId = useAtomValue(selectedProfileIdAtom)

  const activeTasks: Array<{ profileId: string; taskId: string }> = []
  for (const [profileId, meta] of Object.entries(profileMetaById)) {
    const taskId = meta.taskId
    if (
      meta.status === "processing" &&
      typeof taskId === "string" &&
      taskId.length > 0
    ) {
      activeTasks.push({ profileId, taskId })
    }
  }

  return (
    <>
      {activeTasks.map(({ profileId, taskId }) => (
        <TaskStreamSubscriber
          key={`${profileId}:${taskId}`}
          profileId={profileId}
          taskId={taskId}
        />
      ))}
      {selectedProfileId ? (
        <ProfileHydratorSubscriber
          key={selectedProfileId}
          profileId={selectedProfileId}
        />
      ) : null}
    </>
  )
}
